import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fecthUsersFailure,
  fetchUsersStart,
  fetchUsersSuccess,
} from "../../store/features/users/usersSlice";

const URL = buildApiUrl("/api/v1/user/user/");

const getUsersApi = async (accessToken, search = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: search || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchUsersSaga(action) {
  try {
    const { accessToken, search } = action.payload;
    const usersData = yield call(getUsersApi, accessToken, search);
    yield put(fetchUsersSuccess(usersData));
  } catch (error) {
    yield put(fecthUsersFailure(error.message));
  }
}

export default function* usersSaga() {
  yield takeLatest(fetchUsersStart.type, fetchUsersSaga);
}
